/*
 * Entry point of the application.
 * Only platform bootstrapping code should be here.
 * For app-specific initialization, use `app/app.component.ts`.
 */

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from '@app/app.module';
import { environment } from '@env/environment';

// import function to register Swiper custom elements
import { register } from 'swiper/element/bundle';
// register Swiper custom elements
register();

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('firebase-messaging-sw.js')
    .then((registration) => {
      //console.log('✅ Firebase messaging service worker registrado:', registration);
    })
    .catch((err) => {
      console.error('❌ Error registrando el Service Worker de Firebase:', err);
    });
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => {
    console.error('Error al iniciar la aplicación:', err);
    // En producción, mostrar error visible para diagnóstico si la app abre en blanco
    if (typeof document !== 'undefined') {
      document.body.innerHTML = `
        <div style="font-family:sans-serif;padding:20px;max-width:600px;margin:50px auto;background:#fff3cd;border:1px solid #ffc107;border-radius:8px;">
          <h2 style="color:#856404;">Error al cargar la aplicación</h2>
          <p>Abre la consola del navegador (F12) para ver el error detallado.</p>
          <pre style="background:#fff;padding:10px;overflow:auto;font-size:12px;">${err?.message || err}</pre>
          <p><a href="/" style="color:#0054e9;">Recargar página</a></p>
        </div>
      `;
    }
  });
